module.exports = __webpack_public_path__ + "static/media/react200.1fc9e183.png";